<template>
  <div class="button-wrapper">
    <md-button
      :class="buttonClasses"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <slot />
    </md-button>
    <slot name="tooltip" />
  </div>
</template>

<script>
export default {
  name: "Button",
  props: {
    buttonClasses: {
      type: [String, Array, Object],
      default: () => ""
    }
  }
};
</script>

<style scoped lang="scss">
  .button-wrapper {
    display: inline-block;
    margin: 10px 1px;

    button {
      margin: 0;
    }
  }
</style>
